import { FC } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { Translate } from "@/components/Application/Translate";

interface ILoadingProps {
	loading: boolean;
}

export const Loading: FC<ILoadingProps> = ({ loading, children }) => {
	return (
		<>
			{loading ? (
				<Box
					display="flex"
					justifyContent="center"
					alignItems="center"
					height="100vh"
					width="100vw"
				>
					<Box textAlign="center">
						<CircularProgress color="error" size={50} />

						<Translate
							String="Application.Loading"
							HTMLTag="h1"
							className="heading"
						>
							SATOS is loading
						</Translate>
					</Box>
				</Box>
			) : (
				children
			)}
		</>
	);
};
